<script>
import ChooseAvatar from "@/views/components/ChooseAvatar.vue";
import {mapState, mapMutations} from "vuex";
import DepService from "@/api/services/depService";
import TriviaService from "@/api/services/triviaService";

export default {
  name: "profile",
  components: {
    ChooseAvatar
  },
  computed: {
    ...mapState(['user', "productId", 'userStats', 'isFreeUser', 'myBundle']),
    profileImageSrc() {
      if (this.profileImage) {
        return require(`@/assets/profile/avatar-${this.profileImage}-selected.png`);
      }

      return null;
    },
    successRate() {
      if (!this.userStats?.TotalQuestionsAnswered || this.userStats.TotalQuestionsAnswered === 0) {
        return 0;
      }

      const rate = (this.userStats.TotalQuestionsCorrect / this.userStats.TotalQuestionsAnswered) * 100;

      return Math.round(rate);
    }
  },
  data() {
    return {
      showAvatarPopup: false,
      profileImage: localStorage.getItem('avatar'),
      localAvatar: localStorage.getItem('avatar'),
      username: undefined,
    }
  },

  methods: {
    ...mapMutations(['setUserStats']),
    openAvatarPopup() {
      this.showAvatarPopup = true;
    },
    async updateProfileImage() {
      const response = await DepService.getUserViaProductId(this.user.msisdn, this.productId)
      const user = response.data.user;

      this.profileImage = user.avatar ?? this.localAvatar ?? null
      this.username = user.username
    },
    async getUserStats() {
      const recordsets = await TriviaService.getUserStats(this.user.msisdn, this.productId, this.user.serviceId);

      this.setUserStats(recordsets?.[0]?.[0])
    },
    goToTerms() {
      this.$router.push('/terms')
    },
    goToUpgrade() {
      this.$router.push('/upgrade')
    },
    goToManageSubscription() {
      if (!this.isFreeUser) this.$router.push('/manage-subscription')
      else return
    },
    goToMyBundle() {
      window.location.href = 'https://playbundles.mtn.co.za/'
    },

  },
  async beforeMount() {
    await this.updateProfileImage()
    await this.getUserStats()

    if (!this.profileImage) {
      this.showAvatarPopup = true;
    }
  }
}
</script>

<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-12 mt-4 position-relative">

    <div class="col-12 d-flex justify-content-between align-items-center px-3">
      <img :src="isFreeUser ? require('@/assets/logos/logo-free.png') : require('@/assets/logos/logo-vip.png')"  class="logo" alt="logo" />
      <div class="coin-box d-flex align-items-center justify-content-center text-center coin-position">
        <span class="fw-bold text-dark me-1">{{userStats?.TotalCoins}}</span>
        <img src="@/assets/gameplay/coins-large.png" alt="Coin Icon" class="coin-icon"/>
      </div>
    </div>

    <div class="col-12 d-flex flex-column align-items-center mt-4">
      <div class="profile-wrapper position-relative mb-2" @click="openAvatarPopup">
        <img v-if="profileImageSrc" :src="profileImageSrc" alt="Profile Picture" class="profile-pic rounded-circle"/>
        <img  v-if="profileImage === undefined"  src="@/assets/profile/edit-btn.png" alt="Edit" class="edit-icon"/>
      </div>
      <div class="username-wrapper position-relative ">
        <div @click="this.$router.push({ name: 'username', query: { edit: 'true' } })" class="username-box d-flex align-items-center justify-content-center fw-semibold">
          <span class="username-text">{{this.username}}</span>
        </div>
        <img src="@/assets/profile/edit-icon.png" alt="Edit" class="edit-username-icon"/>
      </div>
    </div>

    <div class="col-9 d-flex justify-content-around mt-4 px-3">
      <div class="text-center">
        <div class="stat-value">{{userStats?.TotalQuestionsAnswered}}</div>
        <small class="text-muted">Games Played</small>
      </div>
      <div class="text-center">
        <div class="stat-value">{{successRate}}%</div>
        <small class="text-muted">Success Rate</small>
      </div>
    </div>

    <div class="col-12 d-flex flex-column gap-3 mt-4 px-5">
      <div class="terms-link d-flex align-items-center justify-content-center " @click="goToTerms">
        <img src="@/assets/profile/t-and-c-icon.png" alt="Terms Icon" class="terms-icon me-2"/>
        <span class="terms-text">Terms & Conditions</span>
      </div>

      <div class="subscription-link d-flex align-items-center justify-content-center">
        <img src="@/assets/profile/subscription-icon.png" alt="Subscription Icon" class="subscription-icon me-2"/>
        <span :class="isFreeUser ? 'subscription-text-free' : 'subscription-text-vip'" @click="goToManageSubscription">Manage Subscription</span>
      </div>
    </div>

    <div v-if="isFreeUser" class="col-12 d-flex justify-content-center mt-auto mb-4">
      <div class="cta-button" @click="goToUpgrade">Get More Questions?</div>
    </div>

    <div v-if="myBundle" class="col-12 d-flex justify-content-center mt-auto mb-4 px-5">
      <img src="@/assets/profile/my-bundle-btn.png" alt="My Bundle" class="my-bundle-btn" @click="goToMyBundle"/>
    </div>

  </div>
  <ChooseAvatar
      v-if="showAvatarPopup"
      @close="showAvatarPopup = false"
      @avatar-selected = "updateProfileImage"
  />

</template>

<style scoped>
.logo {
  width: 136px;
}

.coin-icon {
  width: 20px;
  height: 20px;
}

.profile-wrapper {
  width: 160px;
  height: 160px;
}

.profile-pic {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.edit-icon {
  position: absolute;
  top: 60px;
  right: 68px;
  width: 25px;
  height: 25px;

}

.edit-username-icon {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.coin-box {
  width: 85px;
  height: 34px;
  border: 1px solid #000;
  border-radius: 42px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.coin-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.coin-position {
  position: absolute;
  top: 8px;
  right: 16px;

}

.username-text {
  font-family: 'Clash Display', sans-serif;
  font-weight: 400;
  font-size: 17px;
  line-height: 100%;
  letter-spacing: 0;
  color: #7A7F83;
}

.username-box {
  width: 340px;
  height: 55px;
  border: 1px solid #CCCCCC;
  border-radius: 27px;
  background-color: transparent;
  font-size: 16px;
}

.stat-value {
  font-family: 'Clash Display', sans-serif;
  font-weight: 700;
  font-size: 30px;
  line-height: 38px;
  letter-spacing: 0;
  text-align: center;
  color: #000F56;
}

.terms-link {
  width: 211px;
  height: 25px;
  border-bottom: 1px solid #010A5D59;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.terms-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.terms-text {
  font-family: 'Clash Display', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  color: #000000;
}

.subscription-link {
  width: 211px;
  height: 25px;
  border-bottom: 1px solid #CCCCCC;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
}

.subscription-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.subscription-text-free {
  font-family: 'Clash Display', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  color: #CCCCCC;
}

.subscription-text-vip {
  font-family: 'Clash Display', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1;
  color: #000000;
}

.my-bundle-btn {
  width: 340px;
  max-width: 100%;
  height: auto;
  cursor: pointer;
  border-radius: 16px;
  transition: transform 0.15s ease;
  animation: myBundleGlow 2s ease-in-out infinite;
}

.my-bundle-btn:active {
  transform: scale(0.97);
}

@keyframes myBundleGlow {
  0%, 100% {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
  }
  50% {
    box-shadow: 0 4px 22px rgba(255, 203, 5, 0.5);
  }
}

.cta-button {
  width: 340px;
  height: 46px;
  background-color: #FFCB05;
  border-radius: 23px;
  font-family: 'Clash Display', sans-serif;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  cursor: pointer;
}
</style>